module.exports = __webpack_public_path__ + "static/media/wurm-6.697c13bf.JPG";